import { apiService } from "../api";
import { Order } from "../orderService";

export interface FilterOrdersRequest {
  status?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface OrdersResponse {
  orders: Order[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface UpdateOrderStatusRequest {
  status: string;
}

export const adminOrderService = {
  getAll: async (
    filters?: FilterOrdersRequest
  ): Promise<OrdersResponse> => {
    const params = new URLSearchParams();
    if (filters?.status) params.append("status", filters.status);
    if (filters?.startDate) params.append("startDate", filters.startDate);
    if (filters?.endDate) params.append("endDate", filters.endDate);
    if (filters?.search) params.append("search", filters.search);
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.limit) params.append("limit", filters.limit.toString());

    const queryString = params.toString();
    const url = `/admin/orders${queryString ? `?${queryString}` : ""}`;
    return await apiService.get<OrdersResponse>(url);
  },

  getById: async (id: string): Promise<Order> => {
    return await apiService.get<Order>(`/admin/orders/${id}`);
  },

  updateStatus: async (
    id: string,
    data: UpdateOrderStatusRequest
  ): Promise<Order> => {
    return await apiService.patch<Order>(`/admin/orders/${id}/status`, data);
  },

  exportCSV: async (filters?: FilterOrdersRequest): Promise<Blob> => {
    const params = new URLSearchParams();
    if (filters?.status) params.append("status", filters.status);
    if (filters?.startDate) params.append("startDate", filters.startDate);
    if (filters?.endDate) params.append("endDate", filters.endDate);
    if (filters?.search) params.append("search", filters.search);

    const queryString = params.toString();
    const url = `/admin/orders/export/csv${queryString ? `?${queryString}` : ""}`;
    
    const token = localStorage.getItem("admin_token");
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1"}${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to export orders");
    }

    return await response.blob();
  },
};

